import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MenuController, NavController } from '@ionic/angular';
import * as CryptoJS from "crypto-js";
import { MessagesService } from 'src/app/services/messages.service';
import { MustMatch } from '../../helpers/must-match.validator';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss'],
})
export class ResetComponent {

  resetForm: UntypedFormGroup;

  constructor(
    private menuCtrl: MenuController,
    private activatedRoute: ActivatedRoute,
    private navCtrl: NavController,
    private authService: AuthService,
    private messagesService: MessagesService,
  ) {
    this.handleMenu(false);
    const token = this.activatedRoute.snapshot.paramMap.get('token');
    const emailEncrypted = this.activatedRoute.snapshot.paramMap.get('email');

    const email = CryptoJS.AES.decrypt(emailEncrypted, "segredo").toString(CryptoJS.enc.Utf8)

    this.resetForm = new UntypedFormGroup({
      token: new UntypedFormControl(token, [Validators.required]),
      email: new UntypedFormControl(email, [Validators.required, Validators.email]),
      password: new UntypedFormControl('', [Validators.required, Validators.minLength(8)]),
      password_confirmation: new UntypedFormControl('', [Validators.required, Validators.minLength(8)]),
    }, {
      validators: MustMatch('password', 'password_confirmation')
    })
  }

  async handleMenu(enable: boolean) {
    await this.menuCtrl.enable(enable);
  }

  reset() {
    this.resetForm.markAllAsTouched();
    if (!this.resetForm.valid) return;

    const values = this.resetForm.value

    this.authService
      .reset(values.token, values)
      .subscribe({
        next: () => this.login(),
        error: (err: HttpErrorResponse) => {
          if (err.error.status == 404)
            this.messagesService.error({
              header: 'Atenção',
              message: 'O token perdeu a validade.'
            })
        }
      })
  }

  login() {
    // const payload = this.resetForm.value
    // this.authService
    //   .login(payload)
    //   .subscribe({
    //     next: () => this.navCtrl.navigateRoot('/dashboard'),
    //     error: (error) => console.error(error)
    //   })
  }

}
